// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3r218","containerItemsCenter":"Skeleton_containerItemsCenter__1NUW6"};